// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"style__wrapper___3DRfC","intro":"style__intro___SkvuY","title":"style__title___1UETF","image":"style__image___2jIaa","content":"style__content___2QX6k","ingredients":"style__ingredients___FmxoE","directions":"style__directions___N7b0_","direction":"style__direction___3r06Z"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/recipeDetails/style.scss
 ** module id = 367
 ** module chunks = 0
 **/